import React from "react"
import clsx from "clsx"
import { get as getFromPath } from "lodash-es"
import { CardMedia, CardContent, makeStyles, Grid, Box, Typography } from "@material-ui/core"
import { IMonetaryAmount } from "shared/Types/appTypes"
import Card from "shared/Components/Card/Card"
import { HomeCardDescription } from "shared/Components/Skeleton/HomeCardDescription"
import { HomeCardTitle } from "shared/Components/Skeleton/HomeCardTitle"
import { OnlyXLeftTag } from "mobile/Screens/OrderLunch/components/OnlyXLeftTag"
import { OfferTag } from "mobile/Screens/OrderLunch/components/OfferTag"

const useStyles = makeStyles((theme) => ({
    productName: {
        float: "left",
        display: "block",
        marginRight: theme.spacing(1),
        maxWidth: "80%",
    },
    cardTitleWrap: {
        flexDirection: "column",
        gap: "0.25rem",
    },
    productCardContent: {
        padding: "0.5rem 0",
    },
    updateProductCardContent: {
        "&.MuiCardContent-root:last-child": {
            paddingBottom: "0.25rem",
        },
    },
    relative: {
        position: "relative",
    },
    description: {
        clear: "both",
        margin: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        width: "100%",
    },
    tagsContainer: {
        display: "flex",
        gap: "0.375rem",
        marginTop: "0.625rem",
    },
    headerTag: {
        color: theme.palette.common.white,
        borderRadius: "0.25rem",
        padding: "0 0.375rem",
        fontWeight: 500,
        letterSpacing: -0.25,
        width: "fit-content",
        margin: 0,
    },
}))

interface IProps {
    resource: any
    onClick: (resource: any) => void
    resourceTitleProp: string
    resourceImageProp: string
    headerTagTextProp: string
    resourcePriceProp?: string
    resourceSubTitleProp?: string
    headerTagColorProp?: string
    updateProductCardUi?: boolean
}

export default function ResourceCard(props: IProps) {
    const classes = useStyles()

    function headerTag() {
        if (!getFromPath(props.resource, props.headerTagTextProp)) {
            return null
        }

        return (
            <Typography
                variant="caption"
                className={classes.headerTag}
                style={{
                    backgroundColor:
                        props.headerTagColorProp && getFromPath(props.resource, props.headerTagColorProp)
                            ? getFromPath(props.resource, props.headerTagColorProp)
                            : "rgba(0,0,0,0.31)",
                }}
            >
                {getFromPath(props.resource, props.headerTagTextProp)}
            </Typography>
        )
    }

    function pricing(resource: any) {
        if (!props.resourcePriceProp || !getFromPath(props.resource, props.resourcePriceProp)) {
            return <div />
        }

        return (
            <HomeCardDescription>
                {(getFromPath(props.resource, props.resourcePriceProp) as IMonetaryAmount).formatted}
            </HomeCardDescription>
        )
    }

    const productsOnSale = props.resource?.offerDetails?.productsOnSale

    return (
        <div onClick={() => props.onClick(props.resource)} style={{ width: "100%" }}>
            <Card height="100%" width="100%" boxShadow="none" borderRadius=".25rem">
                <div className={classes.relative}>
                    <CardMedia
                        component="img"
                        alt={getFromPath(props.resource, props.resourceTitleProp)}
                        height="172"
                        style={{ borderRadius: ".25rem" }}
                        image={getFromPath(
                            props.resource,
                            props.resourceImageProp,
                            "https://facilitynet.dk/remote/burgers.jpg"
                        )}
                        title={getFromPath(props.resource, props.resourceTitleProp)}
                    />
                    <OfferTag product={props.resource} top="0.75rem" right="0.75rem" />
                </div>
                <Box className={classes.tagsContainer}>
                    {headerTag()}
                    <OnlyXLeftTag amount={productsOnSale} variant="default" />
                </Box>
                <CardContent
                    className={clsx(
                        classes.productCardContent,
                        !!props.updateProductCardUi && classes.updateProductCardContent
                    )}
                >
                    <Grid container justifyContent="space-between" wrap="nowrap" className={classes.cardTitleWrap}>
                        <HomeCardTitle className={classes.productName}>
                            {getFromPath(props.resource, props.resourceTitleProp)}
                        </HomeCardTitle>

                        {props.resourceSubTitleProp && getFromPath(props.resource, props.resourceSubTitleProp) ? (
                            <HomeCardDescription className={classes.description}>
                                {getFromPath(props.resource, props.resourceSubTitleProp)}
                            </HomeCardDescription>
                        ) : (
                            ""
                        )}
                    </Grid>
                    {pricing(props.resource)}
                </CardContent>
            </Card>
        </div>
    )
}
